//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { WebhookEntityType, WebhookNotificationType } from './Enums';

export class WebhookEntityNotificationType extends ItemBase {
    EntityType: WebhookEntityType = WebhookEntityType.Attendance;
    NotificationType: WebhookNotificationType = WebhookNotificationType.Added;

    constructor(initializer?: Partial<WebhookEntityNotificationType>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "WebhookEntityNotificationType";
}
